itsoftApp.createModule("dragNDropFile", function () {
    const module = this;
    const BYTES_IN_MB = 1048576

    const initDrag = function (form, cb) {
        const dropFileZone = form.querySelector('.js-file-zone');

        if (!dropFileZone) {
            return;
        }

        const hintText = form.querySelector('.js-file-hint-text');
        const outputText = form.querySelector('.js-file-status');
        const loaderFile = form.querySelector('.js-file-loader');
        let fileInstance;

        ['dragover', 'drop'].forEach(function(event) {
            document.addEventListener(event, function(evt) {
                evt.preventDefault()
                return false
            })
        })

        dropFileZone.addEventListener('dragenter', function(event) {
            dropFileZone.classList.add('upload-zone_dragover');
            dropFileZone.classList.add('js-dragover');
        })

        dropFileZone.addEventListener('dragleave', function(event) {
            dropFileZone.classList.remove('upload-zone_dragover');
            dropFileZone.classList.remove('js-drag-leave');
        })

        dropFileZone.addEventListener('drop', function(event) {
            let fileInstance = event.dataTransfer.files[0]
            console.log("DROP")

            if (fileInstance.size > 3 * BYTES_IN_MB) {
                alert('Принимается файл до 3 МБ')
                return false
            } else {
                cb(fileInstance);
            }

            // if (fileInstance.type.startsWith('image/')) {
            // processingUploadFile(fileInstance)
            // } else {
            //     alert('Можно загружать только изображения')
            //     return false
            // }
        })
    }

    function processingUploadFile(fileInstanceUpload) {
        if (fileInstanceUpload != undefined) {
            const dropZoneData = new FormData()
            const xhr = new XMLHttpRequest()

            dropZoneData.append('file', fileInstanceUpload)

            xhr.upload.addEventListener('progress', function() {
                hintText.classList.remove('upload-hint_visible');
                hintText.classList.remove('js-visible');
                loaderFile.classList.add('upload-loader_visible');
                loaderFile.classList.add('js-visible');
            })

            // xhr.open('POST', 'upload_processing.php', true)

            // xhr.send(dropZoneData)

            xhr.onload = function (event){
                if (xhr.status == 200) {
                    loaderFile.classList.remove('upload-loader_visible');
                    loaderFile.classList.remove('js-visible');
                    outputText.textContent = `Файл «${fileInstanceUpload.name}» загружен успешно`
                } else {
                    loaderFile.classList.remove('upload-loader_visible');
                    loaderFile.classList.remove('js-visible');
                    outputText.textContent = `Файл не загружен. Ошибка ${xhr.status} при загрузке файла.`
                }
            }
        }
    }

    module.init = initDrag;
});